export const steps = [
  {
    target: "#categories",
    content: "Выберите категорию услуг",
    disableBeacon: true,
  },
  {
    target: "#subcategories",
    content: "Выберите подкатегорию, чтобы найти то, что нужно",
    disableBeacon: true,
  },
  {
    target: "#filter",
    content: "Фильтруйте список услуг для более удобного поиска",
    disableBeacon: true,
  },
  {
    target: "#card",
    content: "Нажмите на карточку, чтобы перейти к описанию услуги",
    disableBeacon: true,
  },
  {
    target: "#viewSwitcher",
    content: "Меняйте отображение с плитки на список, и наоборот",
    disableBeacon: true,
  },
  {
    target: "#profile",
    content:
      "Здесь находится ваш профиль, а в нем - текущие и выполненные заказы",
    disableBeacon: true,
  },
  {
    target: "#profilemob",
    content:
      "Здесь находится ваш профиль, а в нем - текущие и выполненные заказы",
    disableBeacon: true,
  },
];
